/*globals $ */
import once from 'lodash/once';

const contact = {
  /**
   * Init engine. Wrapped in lodash once to make sure it's not called repeatedly
   */
  init: once(() => {
    contact.initPopUp();
  }),
  /**
   * Init for binding events
   */
  initPopUp: () => {
    document.querySelectorAll('.auto-mail-button, .reminder-form').forEach(container => {
      container.addEventListener('click', e => contact.togglePopUp(e));
    });

    document.querySelectorAll('.popup-holder').forEach(container => {
      const closebutton = container.querySelector('.popup-close');
      closebutton.addEventListener('click', e => {
        const openedPopup = document.querySelector('.popup-overlay.open');
        contact.togglePopUp(e, openedPopup.classList.contains('reminder-form-popup-overlay'))
      });
    });

    const fdOfferBtn = document.querySelector('#request-fd-offer');

    if (fdOfferBtn) {
      fdOfferBtn.addEventListener('click', function(event) {
        contact.togglePopUp(event);
        $('input[value=fd-offer]').trigger('click');
      });
    }
  },
  /**
   * Toggle event for mail-contact links
   * @param  {event} e events
   * @param {boolean} closingReminderPopup - If closing reminder popup, this is true
   */
  togglePopUp: (e, closingReminderPopup = false) => {
    e.preventDefault();

    let contactPopupOverlayElement = document.querySelector('.auto-contact-popup');

    if(e.target.closest('a').classList.contains('reminder-form') || closingReminderPopup) {
      contactPopupOverlayElement = document.querySelector('.reminder-form-popup-overlay');
    }

    if( contactPopupOverlayElement ) {
      contactPopupOverlayElement.classList.toggle('open');
    }
    window.scrollTo({
      top: 100,
      behavior: 'smooth',
    });
  },
};

export default contact;
